import React, { useState, useEffect } from "react";
import axios from "axios";
import useAuth from "../auth/hooks/useAuth";
import { AssignmentsContainer } from "./styled_components/containers";
import Clash from "./components/clash";
import Practice from "../games/components/Show/Practice";
import Learn from "../games/components/Show/Learn";
import NumInt from "../games/applications/NumeracyIntervention/Rating"
import MTC from "../games/applications/MTC/Practice"
import Assessment from "../games/applications/MathsAssessments/Basic"
import { Scale } from 'react-scaling';
import { Router, navigate } from "@reach/router";

import BattleBG from "../games/assets/battle_screen.png"

//import useUsername from "../games/hooks/useUsername";

import styled from "styled-components";

function Assignments(props) {
    const { state } = useAuth();
    const { access_token } = state;
    const [assignments, updateAssignments] = useState(null);
    const [doingAssignment, updateDoingAssignment] = useState(null);
    const [clashLeaderboard, setClashLeaderboard] = useState(null);
    const [clashRecent, setClashRecent] = useState(null);
    const [refresher, setRefresher] = useState(false);

    //var details;
    //details = useUsername();
   //console.log(details);

    var game = {
        id: 23,
        game_type: "assessnumeracy"
    }


    function DoAssignment() {
        console.log(assignments);
        console.log(doingAssignment);
        updateDoingAssignment();
    }

    function EndAssignment() {
        updateDoingAssignment(null);

        axios({
            url: `${process.env.REACT_APP_OAUTH_URL}/api/homework`,
            method: "get",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${access_token}`
            }
        }).then((response) => {
            if (response.data !== undefined) {
                var i;
                var count = 0;
                console.log(response.data);
                var temphomeworks = [];
                response.data.forEach(element => {
                    var temphomework = element;
                    console.log(element);
                    if (element.custom_list != undefined) {
                    var customlist = JSON.parse(temphomework.custom_list).list;
                    console.log("NOT UNDEFINED");
                    console.log(customlist);
                    /*
                    var temptopics = [];     
                    //add topics 
                    customlist.forEach(question => {
                        let topic = {"topic_key":question.id,name}
                    });*/
                    temphomework.customlist = customlist;
                    }
                    temphomeworks.push(temphomework);
                });
                
                updateAssignments(temphomeworks);
                for (i = 0; i < response.data.length; i++) {
                    if (response.data[i].important == 1 && response.data[i].submissions.length == 0 && response.data[i].assessment_type != "clash") {
                        count++;
                    }
                }

                if (count > 0) {
                    props.update(true);
                    console.log("had important");
                    console.log(props.update);
                }
                else {
                    props.update(false);
                    console.log("no important");
                    console.log(props.update);
                }
            }
        });

        setRefresher(!refresher);
    }

    useEffect(() => {
        const getPupilAssignments = async () => {
            try {
                const response = await axios({
                    url: `${process.env.REACT_APP_OAUTH_URL}/api/homework`,
                    method: "get",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${access_token}`
                    }
                });

                if (response.data !== undefined) {
                    console.log(response.data);
                    var temphomeworks = [];
                    response.data.forEach(element => {
                        var temphomework = element;
                        let now = new Date();
                        let startDate = new Date(temphomework.starts_at);
                        let endDate = new Date(temphomework.ends_at);
                            if (now >= startDate && now <= endDate) {
                            console.log(element);
                            if (element.custom_list != undefined) {
                            var customlist = JSON.parse(temphomework.custom_list).list;
                            console.log("NOT UNDEFINED");
                            console.log(customlist);
                            /*
                            var temptopics = [];     
                            //add topics 
                            customlist.forEach(question => {
                                let topic = {"topic_key":question.id,name}
                            });*/
                            temphomework.customlist = customlist;
                            }
                            temphomeworks.push(temphomework);
                        }
                    });
                    
                    updateAssignments(temphomeworks);
                    //change the data
                    var i;
                    var count = 0;
                    var incompleteCounter = 0;
                    var clashCounter = 0;

                    for (i = 0; i < response.data.length; i++) {
                        if (response.data[i].assessment_type != "clash" && response.data[i].important == 1 && response.data[i].submissions.length == 0 && (response.data[i].highest_level_reached == null ||response.data[i].highest_level_reached == 0)) {
                            count++;
                        }

                        if (response.data[i].assessment_type != "clash" && response.data[i].submissions.length == 0 && (response.data[i].highest_level_reached == null ||response.data[i].highest_level_reached == 0)) {
                            incompleteCounter++;
                        }

                        if (response.data[i].assessment_type == "clash" && response.data[i].submissions.length == 0 && (response.data[i].highest_level_reached == null ||response.data[i].highest_level_reached == 0)) {
                            clashCounter++;
                        }


                    }

                    if (count > 0) {
                        props.update(true, incompleteCounter);
                        console.log("had important");
                        console.log(props.update);
                    }
                    else {
                        props.update(false, incompleteCounter);
                        console.log("no important");
                        console.log(incompleteCounter);
                        console.log(props.update);
                        if (clashCounter > 0){
                            props.clashupdate(true, clashCounter);
                        }
                    }
                }
            } catch (e) {
                throw new Error(e);
            }
        };

        getPupilAssignments();
    }, []);

    //clash methods
    useEffect(() => {
        const getClashData = async () => {
            try {
                const response = await axios({
                    url: `${process.env.REACT_APP_OAUTH_URL}/api/classclashscores`,
                    method: "get",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${access_token}`
                    }
                });

                if (response.data !== undefined) {
                    console.log(response.data);
                    response.data.forEach(element => {
                        console.log(element);
                    });
                    if (response.data.length > 0){
                        setClashLeaderboard(response.data);
                    }
                }
            } catch (e) {
                throw new Error(e);
            }
        };

        getClashData();
    }, [refresher]);

    useEffect(() => {
        const getRecentClashBattle = async () => {
            try {
                const response = await axios({
                    url: `${process.env.REACT_APP_OAUTH_URL}/api/recentclashbattlescores`,
                    method: "get",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${access_token}`
                    }
                });

                if (response.data !== undefined && response.data != "") {
                    console.log(response.data);
                    var temphomeworks = [];
                    response.data.forEach(element => {
                        console.log(element);
                    });
                    setClashRecent(response.data);
                }
            } catch (e) {
                throw new Error(e);
            }
        };

        getRecentClashBattle();
    }, [refresher]);

    function GetAssignmentsCount(){
        let count = 0;
        if (assignments == null)
            return 0;

            console.log("ASSIGNMENTS", assignments);
        for (let i = 0; i < assignments.length; i++) {
            const element = assignments[i];
            console.log(element);
            console.log(element.submissions.length);
            if (element.assessment_type == "clash"){
                count++;
            }
        }

        return count;
    }

    function LatestClashResults(){
        if (clashRecent == null){
            return (
                <h2>N/A</h2>
            );
        }

        if (clashRecent.length == 0){
            return (
                <h2>No Scores</h2>
            );
        }
        console.log("recent");
        console.log(clashRecent);

        let recentdata = [];

        for (let i = 0; i < clashRecent.length; i++) {
            const element = clashRecent[i];
            let total = 0;
            let correct = 0;

            let tstats = JSON.parse(element.tstats);

            if (tstats != null){
                for (let x = 0; x < tstats.length; x++) {
                    const stat = tstats[x];
                    total+= parseInt(stat.num_asked);
                    correct+= parseInt(stat.num_correct);
                }
            }
            //do percentage
            let percentage = (100 * correct) / total;
            if (total == 0){
                percentage = 0;
            }


            element.total = total;
            element.wrong = total-correct;
            element.correct = correct;
            element.percentage = percentage;

            var foundAlready = false;

            for (let i = 0; i < recentdata.length; i++) {
                const rd = recentdata[i];
                console.log(rd);
                if (rd.pupil_id == element.pupil_id && rd.id != element.id){
                    console.log("found duplicate");
                    foundAlready = true;
                    recentdata[i].total += element.total;
                    recentdata[i].wrong += total-correct;
                    recentdata[i].correct += element.correct;
                    let percentage = (100 * recentdata[i].correct) / recentdata[i].total;
                    if (total == 0){
                        percentage = 0;
                    }
                    recentdata[i].percentage = percentage;
                }
            }

            if (foundAlready == false){
                recentdata.push(element);
            }

        }

        recentdata.sort(function(a, b) {
            return parseFloat(b.correct) - parseFloat(a.correct);
        });

        return (
            <table style={{fontSize: "15px"}}>
                <tr style={{fontSize: "12px"}}>
                    <th>Name</th>
                    <th>Correct Answers</th>
                    <th>Wrong Answers</th>
                    <th>Percent Correct</th>
                </tr>
                {recentdata.slice(0,5).map(data => (
                   <tr style={{color: CheckStyle(data.pupil)}}>
                        <th>{CheckName(data.pupil)}</th>
                        <th>{data.correct}</th>
                        <th>{data.wrong}</th>
                        <th>{data.percentage.toFixed(1)}%</th>
                    </tr>
                ))}


            </table>
        );

        
    }

    function ClashLeaderboard(){
        if (clashLeaderboard == null){
            return (
                <h2>N/A</h2>
            );
        }
        console.log("LEADERBOARD");
        console.log(clashLeaderboard);
        let html = "";
        //let leaderboard = clashLeaderboard;
        let leaderboard = [];
        if (clashLeaderboard.length > 20){
            //find yourself and then add 10 max each direction
            var pupilPos = 0;
            for (let i = 0; i < clashLeaderboard.length; i++) {
                const result = clashLeaderboard[i];
                if (result.pupil.school_username == state.pupil.school_id){
                    pupilPos = i;
                    leaderboard.push(result);
                }
            }
            //found self then add until 20 and minus until 0
            for (let i = 0; i < pupilPos; i++) {
                const element = clashLeaderboard[i];
                leaderboard.push(element);              
            }
            for (let i = 20; i > pupilPos; i--) {
                const element = clashLeaderboard[i];
                leaderboard.push(element); 
            }
        }else{
            leaderboard = clashLeaderboard;
        }
        
        console.log("FINISHED BOARD");
        console.log(leaderboard);
        leaderboard.sort(function(a, b) {
            return parseFloat(Math.round((b.totalscore/b.battlecount)*10)/10) - parseFloat(Math.round((a.totalscore/a.battlecount)*10)/10);
        });

        /*

        for (let i = 0; i < leaderboard.length; i++) {
            const element = leaderboard[i];
            html+= "<li>"+element.pname+" :" + 
        }*/
        //return html;

        return (
            <table style={{fontSize: "15px"}}>
                <tr style={{fontSize: "12px"}}>
                    <th>Name</th>
                    <th>Total Points</th>
                    <th>Battle amount</th>
                    <th>Avg per battle</th>
                </tr>
                {leaderboard.slice(0,5).map(lb => (
                    <tr style={{color: CheckStyle(lb.pupil)}}>
                        <th>{CheckName(lb.pupil)}</th>
                        <th>{lb.totalscore}</th>
                        <th>{lb.battlecount}</th>
                        <th>{Math.round((lb.totalscore/lb.battlecount)*10)/10}</th>
                    </tr>
                ))}


            </table>
        );
    }

    function CheckStyle(pupil){
        if (CheckName(pupil) == "YOU"){
            return "red";
        }else{
            return "#573474";
        }
    }

    function CheckName(pupil){
        if (state.pupil != null){
            if (pupil.school_username == state.pupil.school_id){
                return "YOU";
            }else{
                return pupil.username;
            }
        }else{
            return pupil.username;
        }
    }


    return doingAssignment ? (

        <div>
            {console.log(doingAssignment)}
            {doingAssignment.galaxy_id == 22 && doingAssignment.galaxy_id != 23 ? (
                <MTC
                    neveragain={true}
                    game={game}
                    access={doingAssignment.assessment_type}
                    homework_id={doingAssignment.id}
                    topics={doingAssignment.topics.map(t => t.topic_key)}
                    homework={doingAssignment}
                    timer ={doingAssignment.timelimit}

                    />
            ) : (
                    <div>

                    </div>
                )}
          {doingAssignment.galaxy_id == 35 ? (
                <Assessment
                    neveragain={true}
                    game={game}
                    homework={doingAssignment} />
            ) : (
                    <div>

                    </div>
                )}
            {doingAssignment.galaxy_id == 23 && doingAssignment.galaxy_id != 22 ? (
                <NumInt
                    neveragain={true}
                    game={game}
                    homework_id={doingAssignment.id}
                />
            ) : (
                <div></div>
                )}


                {doingAssignment.assessment_type != "learn" && doingAssignment.galaxy_id != 23 && doingAssignment.galaxy_id != 22 && doingAssignment.galaxy_id != 35 ? (
                                   
                                   <Practice
                                   neveragain={true}
                                   id={doingAssignment.galaxy_id}
                                   topicKeys = {doingAssignment.topics.map(t => t.topic_key)}
                                   topics={doingAssignment.topics.map(t => t.id)}
                                   startImmediately={true}
                                   onEnd={() => EndAssignment()}
                                   homework_id={doingAssignment.id}
                                   dabs={true}
                                   customlist = {doingAssignment.customlist}
                                   timelimit = {doingAssignment.timelimit}
                                   minimum = {doingAssignment.minimum}
                               >
                                    {console.log("DOING ASSIGNMENT NORMAL")}
                                    </Practice>
                ):(
                    <div></div>
                )}

{doingAssignment.assessment_type == "learn" || doingAssignment.assessment_type == "learn|upper" || doingAssignment.assessment_type == "learn|lower"  ? (
                                    <div>
                                   {console.log("doing learn assignment")}
                                   <Learn
                                   neveragain={true}
                                   type={doingAssignment.assessment_type}
                                   id={doingAssignment.galaxy_id}
                                   topicKeys = {doingAssignment.topics.map(t => t.topic_key)}
                                   topics={doingAssignment.topics.map(t => t.id)}
                                   startImmediately={true}
                                   onEnd={() => EndAssignment()}
                                   homework_id={doingAssignment.id}
                                   dabs={true}
                                   customlist = {doingAssignment.customlist}
                                   timelimit = {doingAssignment.timelimit}
                                   minimum = {doingAssignment.minimum}
                               >
                                    {console.log("DOING ASSIGNMENT")}
                                    </Learn>

                                    </div>
                ):(
                    <div></div>
                )}
        </div>
    ) : (

            <CupContainer style={{backgroundImage:BattleBG}}>
                <Scale scaleTo={1920}>
                    <FlexBox>
                    <ClashFrame><h1>Latest battle results:</h1>{LatestClashResults()}</ClashFrame>
                    <div style={{display: "block"}}>
                    {assignments !== null ? (
                        GetAssignmentsCount() > 0 ? (
                            assignments.map((assignment, index) => {
                                let margin =
                                    (((assignments.length < 4) && (index === 0)) ? "top" :
                                        (((assignments.length < 4) && (index === assignments.length - 1)) ? "bottom" :
                                            null));

                                            if (assignment.assessment_type == "clash"){
                                                return <Clash key={assignment.id} assignment={assignment} margin={margin} playAssignment={updateDoingAssignment} endDate={assignment.ends_at} />
                                            }
                            })
                        ) : (
                                <h1 style={{textAlign: "center"}}>No battle available...</h1>
                            )
                    ) : (
                            <h1 style={{textAlign: "center"}}>Fetching your battles...</h1>
                        )}
                    </div>

                <ClashFrame><h1>Battle leaderboard:</h1>{ClashLeaderboard() }</ClashFrame>
                </FlexBox>
                </Scale>
            </CupContainer>
        );
}

export default Assignments;


const FlexBox = styled.div`
display: flex;

`

const ClashFrame = styled.div`
  width: 400px;
  height: 600px;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 10px;
  border-style: groove;
  display: relative;
  text-align: center;
  padding: 5px;
  margin: 20px;
`;

const CupContainer = styled.div`
    display: flex;
    flex-flow: column nowrap;
    padding-top: 40px;
    padding-bottom: 40px;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 100%;
    background-image: url(${BattleBG});
    background-repeat: no-repeat;
    background-size: cover;
    box-sizing: border-box;
    overflow-y: auto;

    h1 {
        color: #673c8c;
        margin: 0;
        margin-bottom: 0.25em;
        font-size: 4em;
    }

    div:only-child{
        margin: auto 0;
    }

    div.top{
        margin-top: auto;
    }

    div.bottom{
        margin-bottom: auto;
    }
`;
